import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class AccountService {
  GetAccountList() {
    return service.peakRealTimeAPI
      .post("/api/Account/GetAllAccountByMerchantId", {}, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new AccountService();
